
export enum RuleLogicalOperatorCd {
	AND = 'And',
	OR = 'Or'}

